import React from 'react';
import {Feedback} from '@/interface';
import {Modal, Profile, Text, Icon} from '@/ui-kits';
import {cn, formatConsultationDate} from '@/utils/common_functions';
interface FeedbackModalProps {
  feedback: Feedback | null;
  isOpen: boolean;
  onClose: () => void;
  patient_name: string;
  patient_photo: string;
  case_id: string;
}
export const FeedbackModal: React.FC<FeedbackModalProps> = props => {
  const {feedback, patient_name, patient_photo, isOpen, onClose, case_id} = props;
  return (
    <Modal open={isOpen} onClose={onClose} className="rounded-lg w-full max-w-[500px]">
      <div className="flex items-center gap-2">
        <Profile profile_url={patient_photo} username={patient_name} />
        <Text variant="title" className="!font-FigtreeBold text-ui_blue">
          {patient_name}
        </Text>

        <Text key={case_id} variant="small" className="text-ui_blue">
        {feedback?.created_at && formatConsultationDate(feedback.created_at, 'short', '-')}
        </Text>
        
        <button onClick={onClose} className="ml-auto">
          <Icon type="close" className="size-6" />
        </button>
      </div>
      <div
        className={cn(
          'mt-4 border shadow-md border-ui_input_border_dark/30 min-h-[100px] flex rounded-xl bg-gradient-to-b from-white to-ui_sky_blue w-full',
          feedback ? 'flex-col p-4 gap-3' : 'flex items-center justify-center',
        )}>
        {feedback ? (
          <>
            <div className="flex items-center gap-2">
              {Boolean(feedback.rating) &&
                Array.from({length: feedback.rating}).map((_, index) => (
                  <Icon type="star_yellow" className="size-6" key={`star-${index}-${feedback.message}`} />
                ))}
              {Boolean(feedback.rating) &&
                Array.from({length: 5 - feedback.rating}).map((_, index) => (
                  <Icon type="star_grey" className="size-6" key={`star-${index}-${feedback.message}`} />
                ))}
            </div>
            <Text variant="small" className="text-ui_blue text-wrap">
              {feedback.message}
            </Text>
          </>
        ) : (
          <Text variant="small" className="text-ui_blue">
            Feedback not yet received from the patient.
          </Text>
        )}
      </div>
    </Modal>
  );
};
